import { motion } from "framer-motion";

/**
 * Marquee — slow editorial ticker.
 * Animates a single row of duplicated content on the X axis.
 * Reversible + tunable duration.
 */
export default function Marquee({
  items = [],
  duration = 44,
  reverse = false,
  separator = "—",
  className = "",
  textClassName = "",
  "data-testid": testId,
}) {
  // Duplicate so the loop is seamless
  const row = [...items, ...items, ...items, ...items];

  return (
    <div
      data-testid={testId}
      className={`relative w-full overflow-hidden select-none ${className}`}
    >
      <motion.div
        className="flex whitespace-nowrap will-change-transform"
        initial={{ x: reverse ? "-50%" : "0%" }}
        animate={{ x: reverse ? "0%" : "-50%" }}
        transition={{
          duration,
          ease: "linear",
          repeat: Infinity,
        }}
      >
        {row.map((item, i) => (
          <span
            key={`${item}-${i}`}
            className={`inline-flex items-center gap-8 md:gap-14 pr-8 md:pr-14 ${textClassName}`}
          >
            <span>{item}</span>
            <span
              aria-hidden
              className="inline-block opacity-40 text-inherit"
            >
              {separator}
            </span>
          </span>
        ))}
      </motion.div>
    </div>
  );
}
